// File: packages/apps/workoutsmart/src/sync/syncUtils.js
import { applyPatch, deepClone } from 'fast-json-patch';

/**
 * Applies patches while preserving the _isPartial flag if the original was partial.
 * This prevents the UI from thinking a patched partial object is suddenly a full object.
 */
export const applyPatchWithPartialProtection = (currentResource, patches) => {
  const wasPartial = currentResource._isPartial;
  const newDocument = applyPatch(deepClone(currentResource), patches, true, false).newDocument;
  
  if (wasPartial) {
    newDocument._isPartial = true;
  }
  
  return newDocument;
};

/**
 * Merges an update while preserving _isPartial if the update itself isn't a full hydration.
 */
export const mergeUpdateWithPartialProtection = (currentResource, newValue) => {
  const wasPartial = currentResource ? currentResource._isPartial : false;
  
  // If the incoming value explicitly sets _isPartial to false, trust it.
  // Otherwise, if we were partial before, stay partial.
  if (wasPartial && newValue._isPartial !== false) {
    return { ...newValue, _isPartial: true };
  }
  
  return newValue;
};